// extracted by mini-css-extract-plugin
export default {"header":"_23v_S-ni"};